import Breadcrumb from './Breadcrumb'
import SearchBar from './types/SearchBar'
import TopNav from './types/TopNav'

export default function Navbar({ search, breadcrumb, nav, children }) {
  return (
    <>
      {search && <SearchBar />}
      {breadcrumb && <Breadcrumb />}

      {children && (
        <div className='row' style={{ margin: '0' }}>
          <div className='col-12 searchTypeRow'>
            <div className='topnav'>{children}</div>
          </div>
        </div>
      )}

      {nav && (
        <div className='row' style={{ margin: '0' }}>
          <div className='col-12 searchTypeRow'>
            <TopNav />
          </div>
        </div>
      )}
    </>
  )
}
